import { SelectClientRelationship } from '@/shared/components/select-client-relationship';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { putClientRelationshipStageByClientIdRequest } from '@client';

interface StageCellProps {
  client: Client;
}

export function StageCell({ client }: StageCellProps) {
  const dispatch = useDispatch();

  const handleChange = useCallback(
    (value: ClientRelationshipStage | undefined) => {
      dispatch(
        putClientRelationshipStageByClientIdRequest({
          clientId: client.clientId,
          relationshipStage: value,
        }),
      );
    },
    [dispatch, client.clientId],
  );

  return (
    <div className="w-34 [&>div]:gap-0 [&_label]:hidden">
      <SelectClientRelationship
        value={client.clientRelationshipStage}
        onChange={handleChange}
        className="h-6.5! px-2! w-max rounded-full border text-xs"
      />
    </div>
  );
}
